import { createContext, useState, ReactNode } from 'react';

// Définir le type du contexte
type AccueilContextType = {
    playerName: string;
    setPlayerName: (playerName: string) => void;
};

// Créer le contexte avec un type par défaut
const AccueilContextDefault = createContext<AccueilContextType>({
    playerName: '',
    setPlayerName: () => {}
});

export const defaultGameId = 'default-game-id';

// Créer un provider
const AccueilProvider = ({ children }: { children: ReactNode }) => {
    const [playerName, setPlayerName] = useState<string>('');

    return (
        <AccueilContextDefault.Provider
            value={{
                playerName,
                setPlayerName
            }}
        >
            {children}
        </AccueilContextDefault.Provider>
    );
};

export { AccueilContextDefault as AccueilContext, AccueilProvider };
